"use client";

import React from "react";

const cormorant = {
    className: "font-cormorant font-serif",
};

export interface MetricItem {
    num: string;
    unit: string;
    label: string;
}

export interface GuestiqoMetricsBlockProps {
    tag?: string;
    title?: string;
    metrics?: MetricItem[];
}

export default function GuestiqoMetricsBlock({
    tag = "// System Performance",
    title = "Operational Metrics",
    metrics = [
        { num: "98", unit: "/100", label: "Lighthouse Performance Score" },
        { num: "1.5", unit: "s", label: "Mobile Guidebook Initial Load" },
        { num: "60+", unit: "", label: "Reusable Component Primitives" },
        { num: "8", unit: "mo", label: "Timeline Concept to Public Launch" }
    ]
}: GuestiqoMetricsBlockProps) {
    return (
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#1C1C1C] text-[#FDFBF7] w-full" data-header-theme="light">
            <div className="container mx-auto">
                <div className="max-w-2xl mb-16">
                    {tag && <span className="text-xs font-mono text-[#8C8276] uppercase tracking-widest block mb-4">{tag}</span>}
                    {title && <h2 className={`${cormorant.className} text-4xl md:text-5xl font-light text-[#FDFBF7] leading-tight`}>{title}</h2>}
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 border-t border-[#FDFBF7]/10 pt-12">
                    {metrics.map((metric, i) => (
                        <div key={i} className="flex flex-col">
                            <div className="flex items-baseline gap-1">
                                <span className={`${cormorant.className} text-6xl md:text-8xl font-light text-[#FDFBF7]`}>{metric.num}</span>
                                <span className="text-lg text-[#8C8276] font-mono">{metric.unit}</span>
                            </div>
                            <p className="text-xs text-[#8C8276] uppercase tracking-wider font-mono mt-2">{metric.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
